import React, { useContext } from 'react';
import { SettingsContext } from '../../contexts/SettingsContext';

interface BannerProps {
  eventGroupImage?: string | null;
}

const Banner: React.FC<BannerProps> = ({ eventGroupImage }) => {
  const { settings } = useContext(SettingsContext);

  const bannerImage = eventGroupImage || settings.bannerImage;

  if (!bannerImage) return null;

  return (
    <div
      className="banner-image"
      style={{
        backgroundImage: `url(${bannerImage})`,
        backgroundSize: 'unset',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '200px',
      }}
    >
    </div>
  );
};

export default Banner;
